/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-08-16 15:59:09
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2023-11-02 17:45:29
 * @FilePath: \vue-hepha-order\src\views\setting\queryConfig\SettingForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const AddBtnForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    formData:{},
    formField:[
        {
            name:'setting.menuType', // 类型  默认web
            key:'menu_type',
            type:'input',
            disabled:true,
            width:'300px',
            placeholder:'',
        },
        {
            name:'setting.btnName', // 按钮名称
            key:'menu_name',
            type:'input',
            width:'300px',
            required: true,
            placeholder:'eg: setting.order.create',
        },
        {
            name:'setting.menuName', // 所属一级菜单
            key:'menu',
            type:'select',   
            allowClear:true,
            required: true,
            optionToLocale:true,
            width:'300px',
            options:[]
        },
        {
            name:'setting.menuParent', // 所属菜单的父级
            key:'menu_parent',
            type:'input',   
            allowClear:true,
            required: true,
            disabled:true,
            width:'300px',
            placeholder:'base.input',
        },
        {
            name:'setting.menuIndex', // 所属菜单的序号
            key:'menu_index',
            type:'input',
            allowClear:true,
            required: true,
            disabled:true,
            width:'300px',
            placeholder:'base.input',
        },
        {
            name:'setting.menuCategory', // 类型  1：页面（菜单）  2：组件（按钮）
            key:'menu_category',
            type:'input',   
            disabled:true,
            width:'300px',
            placeholder:'',
        },
    ]
}

const UserForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    formData:{},
    formField:[
        {
            name:'setting.role', // 角色
            key:'role',
            type:'select',
            width:'300px',
            placeholder:'base.select',
            options:[]
        },
    ]
}

const AddEmailForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'setting.email',
            key:'email',
            type:'input',
            width:'300px',
            placeholder:'base.input',
        },
    ]
}

const AddMenuForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    formData:{},
    formField:[
        {
            name:'setting.menuName', // 菜单名称
            key:'menu_name',
            type:'input',
            width:'300px',
            required: true,
            placeholder:'base.input',
        },
        {
            name:'setting.menuUrl', // 菜单路由
            key:'menu_url',
            type:'input',   
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'base.input',
        },
        {
            name:'setting.menuParent', // 父级等级
            key:'menu_parent',
            type:'select',   
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'base.input',
            optionToLocale:true,
            options:[]
        },
        {
            name:'setting.parentMenuIndex', // 父级菜单索引
            key:'parent_menu_index',
            type:'input',
            allowClear:true,
            required: true,
            disabled:true,
            width:'300px',
            placeholder:'base.input',
        },
        {
            name:'setting.menuIndex', // 菜单索引
            key:'menu_index',
            type:'input',
            allowClear:true,
            required: true,
            disabled:true,
            width:'300px',
            placeholder:'base.input',
        },
    ]
}

AddBtnForm.formField.forEach(item=>{
    AddBtnForm.formData[item.key] = ''
})

UserForm.formField.forEach(item=>{
    UserForm.formData[item.key] = ''
})

AddEmailForm.formField.forEach(item=>{
    AddEmailForm.formData[item.key] = ''
})

AddMenuForm.formField.forEach(item=>{
    AddMenuForm.formData[item.key] = ''
})

export {
    AddBtnForm,
    UserForm,
    AddEmailForm,
    AddMenuForm
}